document.addEventListener('DOMContentLoaded', function () {

    const {
        createApp
    } = Vue;

    const app = createApp({
        data() {
            return {
                isMounted: false,
                isInitialized: false,
                isLoading: false,
                isModalOpen: false,
                reservationConfirmed: false,
                isLocked: {},
                hashValue: null,
                hasPlayerCountError: false,
                hasShownWarning: false,
                hasMultipleArenas: false,
                cancelCode: null,
                cancelMessage: null,
                cancelSuccess: false,
                selectedPackage: {},
                totalGames: 0,
                
                skipSteps: window.resform?.skipSteps || false,
                defaultArena: window.resform?.defaultArena || '',
                defaultGameType: window.resform?.defaultGameType || '',
                
                isOpen: [],
                expandedArena: {},
                isMobile: false,
                windowWidth: window.innerWidth,
                
                selectedArena: 0,
                selectedGameType: 0,
                hasSelectedArena: false,
                hasSelectedGameType: false,
                arena: {},
                gameType: 0,

                isModalType: false,
                isCheckboxType: false,
                checkboxOptions: [],
                selectedCheckboxes: null,
                
                playerCount: '',
                disallowForeignPlayers: false,
                lockFrom: 12,
                maxPlayers: 22,
                minPlayers: 1,
                
                schedules: {},
                meta: {},
                selectedTimes: {},
                
                places: {},
                events: {},
                specials: {},
                exceptions: {},
                packages: {},
                //showSpecials: false,
                tippyInstances: [],
                
                errors: {},
                formMessage: null,
                
                formData: {
                    name: '',
                    phone: '',
                    email: '',
                    event: '',
                    message: '',
                    agree: 0
                },
                
                datePickerInstance: null,
                selectedDate: resform.todayDmy,

                // Doplňující texty k jednotlivým krokům (z administrace)
                sectionTexts: window.resform?.sectionTexts || {},
            };
        },        
        methods: {
            onResize() {
                this.windowWidth = window.innerWidth;
            },
            toggleArena(id, event) {
                this.expandedArena[id] = !this.expandedArena[id];
                if (event) {
                    event.stopPropagation();
                }
            },
            expandArena(id, event) {
                if (!this.expandedArena[id]) {
                    this.expandedArena[id] = true;
                    if (event) {
                        event.stopPropagation();
                    }
                }
            },
            collapseArena(id) {
                if (this.expandedArena[id]) {
                    this.expandedArena[id] = false;
                }
            },
            checkIfMobile() {
                this.isMobile = window.innerWidth <= 768;
            },
            updateURL() {
                if (this.selectedArena === 0 || !this.selectedArena) {
                    history.pushState("", document.title, window.location.pathname + window.location.search);
                    return;
                }
            
                const selectedPlace = this.places.find(place => place.id === this.selectedArena);
                
                if (selectedPlace && selectedPlace.name) {
                    this.hashValue = selectedPlace.name.code;
                    window.location.hash = this.hashValue;
                } else {
                    history.pushState("", document.title, window.location.pathname + window.location.search);
                }
            },                   
            onSelectEvent(event) {
                const selectedEventId = parseInt(event.target.value);
                this.formData.event = selectedEventId; 
            
                this.$nextTick(() => {
                    const matchingSpecial = this.specials.find(special =>
                        special.event_id.includes(String(this.formData.event)) &&
                        special.arena_id.includes(String(this.selectedArena))
                    );

                    if (matchingSpecial) {
                        this.showSpecials = true;
                
                        if (matchingSpecial.modal) {
                            this.isModalType = true;
                            this.checkboxOptions = [];
                        } else {
                            this.isCheckboxType = true;
                            this.checkboxOptions = matchingSpecial.checkboxOptions || [];
                        }
                    } else {
                        this.showSpecials = false;
                        this.isModalType = false;
                        this.isCheckboxType = false;
                        this.checkboxOptions = [];
                        this.selectedCheckbox = null;
                    }
                
                    this.$forceUpdate();
                });
            },                        
            destroyTippyInstances() {
                if (this.tippyInstances.length) {
                    this.tippyInstances.forEach(instance => instance.destroy());
                    this.tippyInstances = [];
                }
            },
            initFlatpickr() {
                this.datePickerInstance = flatpickr(this.$refs.datePicker, {
                    dateFormat: "d.m.Y",
                    locale: resform.language,
                    minDate: "today",
                    disableMobile: true,
                    defaultDate: new Date(),
                    onChange: (selectedDates, dateStr, instance) => {
                        this.fetchCalendarData(dateStr, this.arena);
                        this.selectedDate = dateStr;

                        this.resetSlots();

                        this.updateLockedStates();
                    }
                });

                //this.selectedDate = this.$refs.datePicker.value;

                /*
                if (!this.selectedDate && this.$refs.datePicker.value) {
                    this.selectedDate = this.$refs.datePicker.value;
                }
                */

                this.selectedDate = this.datePickerInstance.input.value;
            },
            initTippy() {
                this.destroyTippyInstances();
            
                this.tippyInstances = tippy('[data-tippy-content]', {
                    allowHTML: true,
                    interactive: true,
                    maxWidth: 200,
                    theme: 'mercuria',
                    onShow(instance) {
                        const links = instance.popper.querySelectorAll('a');
                        links.forEach(function(link) {
                            link.setAttribute('target', '_blank');
                        });
                    }
                });
            },

            // Spočítá, jestli je zobrazena jen jedna aréna nebo více (pro jeden typ hry, např. holešovice mají více než 1)
            isMultipleArenas() {
                const count = Object.values(this.schedules)
                    .filter(schedule => this.gameType === schedule.game_type.id)
                    .length;

                this.hasMultipleArenas = count > 1;

                return count > 1;
            },

            // Tohle validuje když kliknu na plus u inputu
            incrementPlayerCount() {
                if (this.playerCount < this.maxPlayers) {
                    this.playerCount++;

                    this.hasPlayerCountError = false;
                }

                this.setMinPlayers();
            },

            // Tohle validuje když kliknu na minus u inputu
            decrementPlayerCount() {
                if (this.playerCount > 1) {
                    this.playerCount--;

                    this.hasPlayerCountError = false;
                }

                this.setMinPlayers();
            },

            // Kontroluje a hlídá min. počet hráčů v aréně
            setMinPlayers() {
                if (this.playerCount !== '' && this.playerCount < this.minPlayers) {
                    this.playerCount = this.minPlayers;

                    this.hasPlayerCountError = false;
                }
            },

            // Validuje když přímo píšu do počtu hráčů
            validatePlayerCount(event) {
                let value = event.target.value.replace(/\D/g, '');
                value = parseInt(value, 10);

                if (isNaN(value) || value < 1) {
                    this.playerCount = '';
                    this.hasPlayerCountError = true;
                } else if (value > this.maxPlayers) {
                    this.playerCount = this.maxPlayers;
                    this.hasPlayerCountError = false;
                } else {
                    this.playerCount = value;
                    this.hasPlayerCountError = false;
                }

                this.setMinPlayers();

                //'console.log(this.selectedGameType);
            },
            toggleCheckbox(id) {
                const selectedOption = this.checkboxOptions.find(option => option.id === id);
        
                if (selectedOption) {
                    if (this.selectedCheckbox === id) {
                        this.selectedCheckbox = null;
        
                        const regex = new RegExp(`\\(${selectedOption.name}\\)`, 'g');
                        this.formData.message = this.formData.message.replace(regex, '').trim();
                    } else {
                        this.checkboxOptions.forEach(option => {
                            const regex = new RegExp(`\\(${option.name}\\)`, 'g');
                            this.formData.message = this.formData.message.replace(regex, '').trim();
                        });
        
                        this.selectedCheckbox = id;
                        this.formData.message = (this.formData.message ? this.formData.message + '\n' : '') + `(${selectedOption.name})`;
                    }
        
                    const checkboxes = document.querySelectorAll('.special-checkboxes input[type="checkbox"]');
                    
                    checkboxes.forEach(checkbox => {
                        checkbox.checked = (checkbox.id === `special-checkbox-${id}` && this.selectedCheckbox === id);
                    });
                }
            },
            async checkLockShowWarning(scheduleId) {
                try {
                    if (this.isAlwaysLockedArena || this.hasShownWarning) {
                        return true;
                    }
            
                    if (this.disallowForeignPlayers && this.schedules[scheduleId].lock_from > this.playerCount) {
                        const nonMatchingArena = Object.keys(this.schedules).find(id => 
                            id !== scheduleId
                        );

                        const result = await Swal.fire({                            
                            title: resform.titleTemplate
                                .replace('%s', this.schedules[nonMatchingArena].arena_name),
                                //.replace('%s', this.schedules[nonMatchingArena].arena_size),
                            
                            html: resform.htmlTemplate
                                .replace('%s', this.schedules[scheduleId].arena_name)
                                .replace('%s', this.schedules[scheduleId].arena_name),
                                //.replace('%s', this.schedules[scheduleId].arena_size),

                            showDenyButton: true,
                            showCancelButton: false,
                            confirmButtonText: resform.confirmButtonText,
                            denyButtonText: resform.denyButtonText,
                            allowOutsideClick: false,
                            reverseButtons: true,
                            width: '32em',
                            customClass: {
                                confirmButton: 'confirm-button',
                                denyButton: 'deny-button',
                                title: 'title-class',
                                icon: 'icon-class'
                            },
                            didOpen: () => {
                                Swal.getPopup().focus();
                            }
                        });
            
                        if (result.isDenied) {
                            return false;
                        }
            
                        this.hasShownWarning = true;
                    }
            
                    return true;
                } catch (error) {
                    // console.error('Chyba při zpracování (checkLockShowWarning):', error);
                }
            },            
            async selectSlot(scheduleId, slotTime) {
                const noGapsArenas = this.exceptions.no_gaps || [];
                const isNoGapsAllowed = noGapsArenas.includes(Number(scheduleId));

                try {
                    if (!this.playerCount) {
                        this.hasPlayerCountError = true;
                        this.scrollToElement('item-player-count', -40);
                        return;
                    }

                    const slot = this.schedules[scheduleId].slots[slotTime];
                    
                    if (slot) {
                        slot.status = 'available';
                    }

                    if (!this.isSlotAvailable(slot, slotTime, scheduleId)) {
                        return;
                    }

                    /*
                    if (!this.isSlotAvailable(slot, slotTime)) {
                        //console.log('Slot is not available.');
                        return;
                    }
                    */

                    if (slot.free_capacity < this.playerCount || slot.status === 'disabled') {
                        //console.log('Není dostatek volných míst pro počet vybraných hráčů.');
                        //alert('Není dostatek volných míst pro počet vybraných hráčů.');
                        return;
                    }
                    
                    // this.isLocked[scheduleId]  && this.disallowForeignPlayers
                    if (this.isLocked[scheduleId] && slot.total_players > 0) {
                        //console.log('Rezervace tohoto slotu není možná, protože slot není zcela prázdný.');
                        slot.status = 'disabled';
                        //alert('Rezervace tohoto slotu není možná, protože slot není zcela prázdný.');
                        return;
                    }

                    if (this.playerCount < this.schedules[scheduleId].lock_from) {
                        const canContinue = await this.checkLockShowWarning(scheduleId);
                        
                        if (!canContinue) {
                            this.disallowForeignPlayers = false;
                            return;
                        }
                    }
                
                    if (slot.total_players > 0 && !slot.selected) {
                        const result = await Swal.fire({
                            title: resform.joinConfirmationTitle,
                            showDenyButton: true,
                            showCancelButton: false,
                            confirmButtonText: resform.confirmButtonText,
                            denyButtonText: resform.denyButtonText,
                            allowOutsideClick: false,
                            reverseButtons: true,
                            customClass: {
                                confirmButton: 'confirm-button',
                                denyButton: 'deny-button',
                                title: 'title-class',
                                icon: 'icon-class'
                            },
                            didOpen: () => {
                                Swal.getPopup().focus();
                            }
                        });

                        if (result.isDenied) {
                            return false;
                        }
                    }
                    
                    let times = this.selectedTimes[scheduleId] ? [...this.selectedTimes[scheduleId]] : [];
                    const idx = times.indexOf(slotTime);
                    if (idx === -1) {
                        times.push(slotTime);
                    } else {
                        times.splice(idx, 1);
                    }

                    if (!isNoGapsAllowed && times.length > 1) {
                        times.sort();

                        let slots = Object.keys(this.schedules[scheduleId].slots).sort();
                        let slotIndexes = times.map(time => slots.indexOf(time)).sort((a, b) => a - b);
                        let isConsecutive = true;

                        for (let i = 1; i < slotIndexes.length; i++) {
                            if (slotIndexes[i] - slotIndexes[i - 1] !== 1) {
                                isConsecutive = false;
                                break;
                            }
                        }

                        if (!isConsecutive) {
                            await Swal.fire({
                                title: resform.noGapsTitle,
                                text: resform.noGapsText,
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: resform.confirmButtonText,
                                allowOutsideClick: false,
                                reverseButtons: true,
                                customClass: {
                                    confirmButton: 'confirm-button',
                                    title: 'title-class',
                                    icon: 'icon-class'
                                },
                                didOpen: () => {
                                    Swal.getPopup().focus();
                                }
                            });

                            return;
                        }
                    }

                    slot.selected = !slot.selected;

                    if (!this.selectedTimes[scheduleId]) {
                        this.selectedTimes[scheduleId] = [];
                    }
                    
                    if (slot.selected) {
                        this.selectedTimes[scheduleId].push(slotTime);
                    } else {
                        this.selectedTimes[scheduleId] = this.selectedTimes[scheduleId].filter(time => time !== slotTime);
                    }

                    this.updateSlotAvailability(slotTime);
                } catch (error) {
                    // console.error('Chyba při zpracování (selectSlot):', error);
                }
            },
            updateSlotAvailability(slotTime) {
                Object.keys(this.schedules)
                    .filter(scheduleId => this.schedules[scheduleId].game_type.id === this.selectedGameType) 
                    .forEach(scheduleId => {
                        // TODO: možná to bude zlobit, protože např. Liberec je id 7 ale dvě maze arény mají 8 a 12
                        //console.log("Auto select second arena:", this.exceptions.auto_select_second_arena, scheduleId);
                        
                        if (!this.exceptions.auto_select_second_arena.includes(parseInt(scheduleId))) {
                            return;
                        }
                        
                        const slot = this.schedules[scheduleId].slots[slotTime];
                        
                        if (!slot) {
                            // console.warn(`Slot time ${slotTime} neexistuje v scheduleId ${scheduleId}.`);
                            return;
                        }
            
                        const isSelectedSecondArena = Object.keys(this.selectedTimes).some(id => 
                            id !== scheduleId && this.selectedTimes[id].includes(slotTime)
                        );

                        if (isSelectedSecondArena) {
                            slot.status = 'disabled';
                        } else {
                            slot.status = 'available';
                        }
                    });
            },            
            isSlotAvailable(slot, time, scheduleId) {
                //if (slot.total_players > 0 && this.disallowForeignPlayers) {
                
                /*
                if (slot.total_players > 0 && (this.disallowForeignPlayers && this.isLocked[this.selectedArena])) {
                    return false;
                }
                */

                if (slot.total_players > 0 && (this.disallowForeignPlayers && this.isLocked[scheduleId])) {
                    return false;
                }

                const currentDate = new Date();
                const selectedDate = new Date(this.selectedDate.split('.').reverse().join('-') + ' ' + time);

                if (selectedDate < currentDate) {
                    slot.status = 'disabled';

                    return false;
                }

                if (slot.status == 'disabled') {                    
                    return false;
                }

                const minLead = Number(this.exceptions?.min_lead_time?.[this.selectedArena]) || 0;
                const diffHours = (selectedDate - currentDate) / (1000 * 60 * 60);

                if (diffHours < minLead) {
                    slot.status = 'disabled';
                    return false;
                }

                return ((slot.free_capacity >= this.playerCount) && (slot.status === 'available'));
            },
            openDatePicker() {
                if (this.datePickerInstance) {
                    this.datePickerInstance.open();
                }
            },
            displayTakenTimes() {
                if (this.errors.already_taken) {
                    return Object.entries(this.errors.already_taken).map(([scheduleId, times]) => {
                        const schedule = this.schedules[scheduleId];
                        const scheduleName = schedule?.name || resform.unknownArena;
                        const arenaName = schedule?.arena_name || resform.unknownPlace;

                        return `${scheduleName} (${arenaName}): ${times.join(', ')}`;
                    }).join('; ');
                }
                return '';
            },
            resetForm() {
                this.formData = {
                    name: '',
                    email: '',
                    phone: '',
                    event: '',
                    message: '',
                    agree: 0
                };

                Object.keys(this.schedules).forEach(scheduleId => {
                    const schedule = this.schedules[scheduleId];
                    Object.keys(schedule.slots).forEach(slotTime => {
                        const slot = schedule.slots[slotTime];
                        slot.selected = false;
                    });
                });

                this.showSpecials = false;
                this.selectedPackage = {};
                this.isAlwaysLockedArena = false;
                this.selectedTimes = {};
                this.playerCount = '';
                this.isLocked = {};
                this.isOpen = [];
                this.expandedArena = [];
            },
            scrollToElement(elm = null, offset = -40) {
                this.$nextTick(() => {
                    if (elm) {
                        const element = document.getElementById(elm);
                        if (element) {
                            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                            const offsetPosition = elementPosition + offset;
                            window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                        }
                    } else {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                });
            },
            submitForm() {
                const formData = new FormData();

                formData.append('name', this.formData.name);
                formData.append('email', this.formData.email);
                formData.append('phone', this.formData.phone);
                formData.append('message', this.formData.message);
                formData.append('agree', this.formData.agree ? '1' : '0');
                formData.append('event', this.formData.event);
                formData.append('totalPlayers', this.playerCount);
                formData.append('action', 'confirm_reservation');
                formData.append('selectedDate', this.selectedDate);
                formData.append('package', this.selectedPackage.id);

                // Někdy je tam místo balíčků modální okno, někdy checkboxy vyžadující volbu
                formData.append('isCheckboxType', this.isCheckboxType ? '1' : '0');
                formData.append('isModalType', this.isModalType ? '1' : '0');

                if (this.isCheckboxType) {
                    formData.append('checkboxSelection', this.selectedCheckbox ? this.selectedCheckbox : '');
                }

                Object.keys(this.isLocked).forEach(scheduleId => {
                    formData.append(`lockRoom[${scheduleId}]`, this.isLocked[scheduleId]);
                });

                Object.keys(this.selectedTimes).forEach(key => {
                    this.selectedTimes[key].forEach(time => {
                        formData.append(`selectedTimes[${key}][]`, time);
                    });
                });
                
                this.sendPostRequest(resform.ajaxurl, formData)
                    .then(response => {

                        if (response.success === false) {
                            this.errors = response.data.errors;
                            this.formMessage = response.data.message;
                            this.scrollToElement('confirm-form');
                        } else {
                            // Musí to být zde
                            this.sendTrackingEvent();

                            this.errors = {};
                            this.formMessage = response.data.message;
                            this.gameType = '0';
                            this.playerCount = '';
                            this.scrollToElement();
                            
                            this.resetForm();

                            this.reservationConfirmed = true;

                            if (this.selectedDate && this.arena) {
                                this.fetchCalendarData(this.selectedDate, this.arena);
                            }
                        }
                    })
                    .catch(error => {
                        // console.error('Chyba při odesílání formuláře:', error);
                    });
            },
            calculateConversionValue() {
                const pocetHracu = this.playerCount || 0;
                const pocetHer = this.calculateTotalGames();
                const hodnotaKonverze = pocetHracu * pocetHer;

                return hodnotaKonverze;
            },     
            calculateTotalGames() {
                return this.selectedTimes ? Object.keys(this.selectedTimes).reduce((total, key) => total + this.selectedTimes[key].length, 0) : 0;
            },    
            sendTrackingEvent() {

                    const selectedPlace = this.places.find(place => place.id === this.selectedArena);

                    const arenaName = selectedPlace.name.name || resform.unknownArena;
                    const zabava = selectedPlace.game_type.find(gameType => gameType.id === this.selectedGameType).name || resform.unknownEntertainment;
                    const pocetHracu = this.playerCount || 0;
                    const pocetHer = this.calculateTotalGames();
                    const hodnotaKonverze = this.calculateConversionValue();

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'form_submit_vytvoreni_rezervace',
                        'arena': arenaName,
                        'zabava': zabava,
                        'pocet_hracu': pocetHracu,
                        'pocet_her': pocetHer,
                        'hodnota_konverze': hodnotaKonverze
                    });
                    
                    /*
                    console.debug('DataLayer push: ', {
                        'event': 'form_submit_vytvoreni_rezervace',
                        'arena': arenaName,
                        'zabava': zabava,
                        'pocet_hracu': pocetHracu,
                        'pocet_her': pocetHer,
                        'hodnota_konverze': hodnotaKonverze
                    });
                    */
            },
            async sendPostRequest(url, data, timeout = 100000) {
                this.isLoading = true;
            
                let bodyData;
            
                if (data instanceof FormData) {
                    bodyData = data;
                } else {
                    bodyData = new URLSearchParams();
                    for (const key in data) {
                        bodyData.append(key, data[key]);
                    }
                }
            
                const fetchWithTimeout = new Promise((resolve, reject) => {
                    const timeoutId = setTimeout(() => {
                        reject(new Error(resform.timeoutError));
                    }, timeout);
            
                    fetch(url, {
                        method: 'POST',
                        body: bodyData,
                        headers: !(data instanceof FormData) ? { 'Content-Type': 'application/x-www-form-urlencoded' } : {}
                    })
                    .then(response => {
                        clearTimeout(timeoutId);
                        if (!response.ok) {
                            reject(new Error(resform.httpErrorTemplate.replace('%s', response.status)));
                        } else {
                            resolve(response.json());
                        }
                    })
                    .catch(error => {
                        clearTimeout(timeoutId);
                        reject(error);
                    });
                });
            
                try {
                    const response = await fetchWithTimeout;
                    this.isLoading = false;
                    return response;
                } catch (error) {
                    this.isLoading = false;
                    // console.error('Chyba při odesílání požadavku:', error);
                    throw error;
                }
            },            
            async fetchCalendarData(date, selectedArena) {
                if (!this.isMounted) return;

                try {
                    if (!selectedArena || typeof selectedArena.ids === "undefined") {
                        return;
                    }

                    const data = await this.sendPostRequest(resform.ajaxurl, {
                        action: 'get_time_table',
                        date: date,
                        id: selectedArena.ids
                    });

                    this.schedules = {};
                    
                    this.schedules = data.schedules;
                    this.meta = data.meta;
                    this.lockFrom = data.meta.lock_from;
                    this.minPlayers = data.meta.min_players;
                    this.maxPlayers = this.maxPlayerInputValue;

                    //console.log(this.maxPlayers);
                    //console.log('Načtené data z kalendáře:', this.lockFrom, this.maxPlayers, this.schedules);

                    this.setFirstAvailableGameType();

                    if (this.schedules && Object.keys(this.schedules).length > 0) {
                        Object.keys(this.schedules).forEach((id) => {
                            this.expandedArena[id] = false;
                        });
                    }

                    this.$nextTick(() => {
                        this.initTippy();
                    });
                } catch (error) {
                    // console.error('Chyba při načítání dat (fetchCalendarData):', error);
                }
            },
            async fetchPlacesData() {
                if (!this.isMounted) return;

                try {
                    const data = await this.sendPostRequest(resform.ajaxurl, {
                        action: 'get_places'
                    });

                    this.places = data.places ?? [];
                    this.events = data.events;
                    this.specials = data.specials;
                    this.exceptions = data.exceptions;
                    this.packages = data.packages;

                    const hash = window.location.hash.replace('#', '');

                    this.showedArena = this.places.find(place => place.name.code === hash)['ids'];
                    
                    if (hash) {
                        this.hashValue = hash;
                        this.selectedArena = this.places.find(place => place.name.code === hash)['id']
                    }
                } catch (error) {
                    //console.error('Chyba při načítání dat (fetchPlacesData):', error);
                }
            },
            setFirstAvailableGameType() {
                if (this.hasSelectedGameType) {
                    return;
                }

                if (this.arena && Array.isArray(this.arena.game_type) && this.arena.game_type.length == 1) {
                    this.gameType = this.arena.game_type[0].id; 

                    this.lockFrom = this.schedules
                } else {
                    this.gameType = '0'; 
                }
            },
            getSortedTimes(id) {
                if (this.selectedTimes[id]) {
                    return this.selectedTimes[id].sort((a, b) => a.localeCompare(b));
                }
                
                return [];
            },
            openModal() {
                this.isModalOpen = true;
                document.body.style.overflow = "hidden";
              },
            closeModal(event, addMessage = false) {
                if (event) {
                    event.preventDefault();
                }

                if (addMessage && !this.formData.message.includes(resform.noPackageMessage)) {
                    this.formData.message = (this.formData.message ? this.formData.message + '\n' : '') + resform.noPackageMessage;
                }                

                if (addMessage) {
                    this.selectedPackage = {};
                }

                this.isModalOpen = false;
                document.body.style.overflow = "";
            },
            resetSlots() {
                Object.keys(this.schedules).forEach(scheduleId => {
                    const schedule = this.schedules[scheduleId];
                    Object.keys(schedule.slots).forEach(slotTime => {
                        const slot = schedule.slots[slotTime];
                        slot.selected = false;
                    });
                });

                this.formData.event = '';
                this.showSpecials = false;
                this.selectedPackage = {};
                this.isAlwaysLockedArena = false;
                this.selectedTimes = {};
                this.isLocked = {};

                this.isModalType = false;
                this.isCheckboxType = false;
                this.checkboxOptions = [];
                this.selectedCheckboxes = null;
            },
            updateLockedStates() {
                if (this.schedules && Object.keys(this.schedules).length > 0) {
                    Object.keys(this.schedules).forEach(scheduleId => {
                        const schedule = this.schedules[scheduleId];
                      
                        if (this.disallowForeignPlayers === true && this.playerCount >= schedule.lock_from) {
                            this.isLocked[scheduleId] = true;
                        } else {
                            this.isLocked[scheduleId] = false;
                        }
                    });
                }

                if (this.isAlwaysLockedArena) {
                    this.exceptions.always_lock_arena.forEach(id => {
                        this.isLocked[id] = true;
                    });

                    //this.disallowForeignPlayers = true;
                }

                //console.log(this.isLocked);
            },
            async cancelReservation() {
                if (!this.isMounted) return;

                this.isLoading = true;

                try {
                    await this.sendPostRequest(resform.ajaxurl, {
                        action: 'cancel_reservation',
                        code: this.cancelCode
                    }).then(response => {
                        if (response.success === false) {
                            this.cancelMessage = response.data.message;
                            this.cancelSuccess = false;
                        } else {
                            this.cancelMessage = response.data.message;
                            this.cancelSuccess = true;
                            this.cancelCode = null;
                        }
                    })
                    .catch(error => {
                        // console.error('Chyba při odesílání:', error);
                    });

                } catch (error) {
                    // console.error('Chyba při načítání dat (cancelReservation):', error);
                }

                this.isLoading = false;
            },
            getCancelCode() {
                const params = new URLSearchParams(window.location.search);
                const cancelCode = params.get('cancel'); 
            
                if (cancelCode) {
                    this.cancelCode = cancelCode;
                }
            },
            selectPackage(packageId) {
                this.selectedPackage = {id: packageId, name: this.packages[packageId]};
                
                if (this.formData.message.includes(resform.noPackageMessage)) {
                    this.formData.message = this.formData.message
                        .replace(resform.noPackageMessage, '')
                        .trim();
                }

                this.closeModal();
            },
            deselectPackage() {
                this.selectedPackage = {};

                if (!this.formData.message.includes(resform.noPackageMessage)) {
                    this.formData.message = (this.formData.message ? this.formData.message + '\n' : '') + resform.noPackageMessage;
                }                
            },
            handleKeyDown(event) {
                if (event.key === 'Escape' || event.key === 'Esc') {
                    this.closeModal();
                }
            },
        },
        computed: {
            isFullyAlwaysLockedGameType() {
                const gameTypeId = this.selectedGameType || this.gameType;

                if (!gameTypeId || !this.schedules || !this.exceptions || !Array.isArray(this.exceptions.always_lock_arena)) {
                    return false;
                }

                const schedulesForType = Object.values(this.schedules)
                    .filter(s => s.game_type && s.game_type.id == gameTypeId);

                if (!schedulesForType.length) {
                    return false;
                }

                const exceptionIds = this.exceptions.always_lock_arena.map(id => parseInt(id));

                const numAlwaysLocked = schedulesForType.filter(s =>
                    exceptionIds.includes(parseInt(s.id))
                ).length;

                return numAlwaysLocked > 0 && numAlwaysLocked === schedulesForType.length;
            },
            lockInfo() {
                const items = Object.values(this.schedules)
                    .filter(s => s.game_type && s.game_type.id == this.selectedGameType);

                if (!items.length) {
                    return { items: [], showArenaNames: false };
                }

                const first = items[0];
                const sameForAll = items.every(s =>
                    String(s.lock_from) === String(first.lock_from) &&
                    String(s.arena_size || '') === String(first.arena_size || '')
                );

                if (sameForAll) {
                    return {
                        items: [first],
                        showArenaNames: false
                    };
                }

                return {
                    items,
                    showArenaNames: items.length > 2
                };
            },
            isArenaOpen() {
                if (!this.schedules || Object.keys(this.schedules).length === 0) return false;
                return Object.values(this.schedules).some(sch => sch.slots && Object.keys(sch.slots).length > 0);
            },
            dynamicMaxHeight() {                
                const windowWidth = this.windowWidth;

                if (windowWidth >= 768) {
                    return 'auto';
                } else {
                    const slotCount = 3;

                    return `${slotCount * 80}px`;
                }
            },
            minLockFrom() {
                if (this.schedules && Object.keys(this.schedules).length > 0) {
                    return Math.min(...Object.values(this.schedules).filter(schedules => schedules.game_type.id == this.selectedGameType).map(schedule => parseInt(schedule.lock_from)));
                }

                return Infinity;
            },
            maxPlayerInputValue() {
                if (this.schedules && Object.keys(this.schedules).length > 0) {
                    return Math.max(...Object.values(this.schedules).filter(schedules => schedules.game_type.id == this.selectedGameType).map(schedule => parseInt(schedule.total_capacity)));
                }

                return Infinity;
            },
            canDisableForeignPlayers() {
                let isAboveMinPlayers = this.playerCount >= this.minLockFrom;

                let areAllSelectedSlotsFree = Object.keys(this.selectedTimes).every(scheduleId => {
                    return this.selectedTimes[scheduleId].every(time => {
                        let schedule = this.schedules[scheduleId];

                        if (!schedule) {
                            // console.warn(`Schedule with ID ${scheduleId} not found.`);
                            return false;
                        }

                        let slot = schedule.slots[time];
                        
                        if (!slot) {
                            // console.warn(`Slot for time ${time} not found in schedule ID ${scheduleId}.`);
                            return false;
                        }

                        return slot.total_players === 0;
                    });
                });

                return isAboveMinPlayers && areAllSelectedSlotsFree;
            },
            hasSelectedTimes() {
                return Object.keys(this.selectedTimes).some(key => this.selectedTimes[key].length > 0);
            },
            formHasErrors() {
                return Object.keys(this.errors).length > 0;
            },
            isAlwaysLockedArena() {
                const matchingArenaIds = Object.values(this.schedules)
                    .filter(schedule => schedule.game_type && schedule.game_type.id === this.gameType)
                    .map(schedule => parseInt(schedule.id));

                const exceptionIds = (this.exceptions?.always_lock_arena ?? []).map(id => parseInt(id));

                //console.log(matchingArenaIds.some(id => exceptionIds.includes(id)));

                return matchingArenaIds.some(id => exceptionIds.includes(id));
            },
        },
        watch: {
            async playerCount(newVal) {

                if (this.playerCount > 0) {
                    this.reservationConfirmed = false;
                }

                try {
                    if (newVal >= this.minLockFrom && this.canDisableForeignPlayers) {

                    } else {
                        this.disallowForeignPlayers = false;
                    }

                    for (let scheduleId of Object.keys(this.schedules).filter(id => this.schedules[id].game_type.id == this.selectedGameType)) {
                        const schedule = this.schedules[scheduleId];
                        
                        if (this.playerCount < schedule.lock_from) {
                            const canContinue = await this.checkLockShowWarning(scheduleId);
                            
                            if (!canContinue) {
                                this.disallowForeignPlayers = false;
                                return;
                            }
                        }
                    }

                    this.updateLockedStates();
                } catch (error) {
                    //console.error('Chyba při zpracování (playerCount):', error);
                }
            },
            async disallowForeignPlayers(newVal) {
                try {
                    if (newVal === true && this.schedules && Object.keys(this.schedules).length > 0) {
                        for (let scheduleId of Object.keys(this.schedules).filter(id => this.schedules[id].game_type.id == this.selectedGameType)) {
                            const schedule = this.schedules[scheduleId];
                            
                            // this.selectedTimes[scheduleId]?.length > 0 && 
                            if (this.playerCount < schedule.lock_from) {
                                const canContinue = true;//await this.checkLockShowWarning(scheduleId);
                                
                                if (!canContinue) {
                                    this.disallowForeignPlayers = false;
                                    return;
                                }
                            }
                        }
                    }
                
                    this.updateLockedStates();
                } catch (error) {
                    // console.error('Chyba při zpracování (disallowForeignPlayers):', error);
                }
            },
            
            gameType(newVal) { console.log(newVal);
                this.hasSelectedGameType = newVal !== '0';
                this.selectedGameType = newVal;

                if (this.hasSelectedGameType && this.meta[newVal]) {
                    this.lockFrom = this.meta[newVal].lock_from; 
                    this.maxPlayers = this.meta[newVal].total_capacity;
                    this.minPlayers = this.meta[newVal].min_players;
                }

                if (newVal && this.meta && this.meta[newVal]) {
                    this.lockFrom = this.meta[newVal].lock_from;
                    this.maxPlayers = this.meta[newVal].total_capacity;
                    this.minPlayers = this.meta[newVal].min_players;
                }

                if (this.playerCount > this.maxPlayers) {
                    this.playerCount = this.maxPlayers;
                }

                this.setMinPlayers();

                this.isMultipleArenas();

                this.resetSlots();
            },

            selectedArena(newVal) {
                if (!Array.isArray(this.places) || !this.places.length) return;
                
                this.hasSelectedArena = newVal !== '0';
                this.selectedTimes = {};
                this.gameType = '0';
                this.hasShownWarning = false;

                if (this.hasSelectedArena) {
                    this.arena = this.places.find(place => place.id === newVal);
                    //this.arena = this.places.find(place => place.id == newVal);

                    this.fetchCalendarData(this.selectedDate, this.arena).then(() => {
                        this.setFirstAvailableGameType(); 
                    });
                } else {
                    this.gameType = '0';
                }

                this.hasSelectedGameType = false;
                this.resetForm();
            },
            reservationConfirmed(newValue) {
                if (newValue) {
                    this.resetForm();

                    this.selectedTimes = {};

                    this.hasSelectedGameType = false;

                    this.fetchPlacesData();

                    if (this.arena && this.selectedDate) {
                        this.fetchCalendarData(this.selectedDate, this.arena).then(() => {
                            this.setFirstAvailableGameType(); 
                        });
                    } else {

                    }
                }
            }
        },
        mounted() {
            this.isMounted = true;

            window.addEventListener('resize', this.onResize);

            this.$nextTick(() => {
                document.addEventListener('click', (event) => {
                    if (event.target.closest('.package-button a')) {
                        event.preventDefault();
                        
                        const packageId = event.target.closest('.package-button a').id;
                        this.selectPackage(packageId);
                    }
                });

                if (this.datePickerInstance) {
                    this.datePickerInstance.setDate(new Date(), true);
                    this.selectedDate = this.datePickerInstance.input.value;
                }

                window.addEventListener('keydown', this.handleKeyDown);

                //this.fetchPlacesData();

                this.fetchPlacesData().then(() => {
                    if (this.skipSteps) {
                        this.selectedArena = this.defaultArena;
                        this.gameType = this.defaultGameType;
                        this.hasSelectedArena = !!this.selectedArena;
                        this.hasSelectedGameType = !!this.gameType;
                    }

                    this.initFlatpickr();
                });

                this.getCancelCode();
            });

            this.checkIfMobile();
            window.addEventListener('resize', this.checkIfMobile);

            this.isInitialized = true;
        },
        beforeUnmount() {
            window.removeEventListener('keydown', this.handleKeyDown);
            window.removeEventListener('resize', this.checkIfMobile);
            window.removeEventListener('resize', this.onResize);

            this.isMounted = false;
        },
    });

    app.mount('#resform');
});

document.addEventListener('DOMContentLoaded', function() {
    Vue.createApp({
        data() {
            return {
                orderStatus: null,
                isInitialized: false,
                discount: {},
                orderConfirmed: true,
                errors: {},
                formMessage: null,
                formData: {
                    name: '',
                    email: '',
                    telephone: '',
                    //note: '',
                    promo: '', 
                    amounts: [{
                        value: ''
                    }]
                },
                availableAmounts: [],
                verified: window.verified || false
            };
        },
        methods: {
            getPaymentStatus() {
                const params = new URLSearchParams(window.location.search);
                const paymentStatus = params.get('payment'); 
                const allowedStatuses = ['PAID', 'PENDING', 'CANCELLED'];
            
                if (!paymentStatus) {
                    this.orderStatus = 'NOT_PROVIDED'; 
                } else if (allowedStatuses.includes(paymentStatus)) {
                    this.orderStatus = paymentStatus;
                } else {
                    this.orderStatus = 'UNKNOWN';
                }

                /*
                if (this.verified) {
                    this.sendTrackingEvent();
                }
                */
            },     
            sendTrackingEvent() {
                
            },            
            addAmount() {
                this.formData.amounts.push({
                    value: ''
                });

                this.orderConfirmed = false;
            },
            removeAmount(index) {
                if (this.formData.amounts.length > 1) {
                    this.formData.amounts.splice(index, 1);
                }
            },
            scrollToElement(elm = null, offset = -40) {
                this.$nextTick(() => {
                    if (elm) {
                        const element = document.getElementById(elm);
                        if (element) {
                            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                            const offsetPosition = elementPosition + offset;
                            window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                        }
                    } else {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                });
            },
            async validateDiscountCode() {
                if (!this.formData.promo || this.formData.promo.trim() === '') {
                    return;
                }

                const formData = new FormData();
                formData.append('action', 'check_discount_code');
                formData.append('promo', this.formData.promo);
                
                await fetch(resform.ajaxurl, {
                    method: 'POST',
                    body: formData
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(response.status);
                    }
                    return response.json();
                })
                .then(response => {
                    if (!response.success) {
                        this.errors = {};
                        this.discount = {};
                        this.errors.promo = response.data.message;
                        this.formMessage = response.data.message;
                    } else {
                        this.discount = response.data.discount;
                        this.errors = {};
                        
                        //this.updateTotal();
                    }
                })
                .catch(error => {
                    // console.error('Chyba při odesílání formuláře:', error);
                });
            },

            async fetchVoucherAmounts() {
                await fetch(resform.ajaxurl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: 'action=get_voucher_amounts'
                    })
                    .then(response => response.json())
                    .then(data => {
                        this.availableAmounts = data.amounts;
                    })
                    .catch(error => {
                        // console.error('Chyba při načítání částek voucherů:', error);
                    });
            },
            async confirmOrder() {
                const formData = new FormData();
                formData.append('action', 'confirm_voucher_order');
                formData.append('name', this.formData.name);
                formData.append('email', this.formData.email);
                formData.append('telephone', this.formData.telephone);
                formData.append('promo', this.formData.promo);
                //formData.append('note', this.formData.note);
                
                this.formData.amounts.forEach((amount, index) => {
                    if (amount.value) {
                        formData.append(`amounts[${index}]`, amount.value);
                    }
                });

                await fetch(resform.ajaxurl, {
                    method: 'POST',
                    body: formData
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(response.status);
                    }
                    return response.json();
                })
                .then(response => {
                    if (!response.success) {
                        this.errors = response.data.errors;
                        this.formMessage = response.data.message;

                        this.scrollToElement('voucher-form');
                    } else {
                        this.errors = {};
                        this.formMessage = response.data.message;
                        
                        window.parent.location.href = response.data.data.redirect_url;
                    }
                })
                .catch(error => {
                    // console.error('Chyba při odesílání formuláře:', error);
                });
            }
        },
        computed: {
            total() {
                let subtotal = this.formData.amounts.reduce((acc, amount) => acc + Number(amount.value || 0), 0);
                if (this.discount && this.discount.discount_type === 'percentage') {
                    subtotal -= subtotal * (this.discount.discount_value / 100);
                } else if (this.discount && this.discount.discount_type === 'fixed') {
                    subtotal -= this.discount.discount_value;
                }

                return subtotal < 0 ? 0 : subtotal;
            },
            hasErrors() {
                return Object.keys(this.errors).length > 0;
            },
            discountInfo() {
                return this.discount.discount_value + ' ' + (this.discount.discount_type == 'percentage' ? '%' : 'Kč');
            }
        },
        mounted() {
            this.fetchVoucherAmounts();

            this.isInitialized = true;

            this.getPaymentStatus();
        }
    }).mount('#voucher-form');

});